module.exports = __webpack_public_path__ + "img/rob_shengjiang.b8998846.png";